import {
  Component,
  HostListener,
  Injectable,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'app-screen-dimensions',
  templateUrl: './screen-dimension-component.html',
  styleUrls: ['./screen-dimension-component.scss'],
})
@Injectable({
  providedIn: 'root',
})
export class ScreenDimensionsComponent implements OnInit {
  screenWidth: number;
  screenHeight: number;

  constructor(private cdRef: ChangeDetectorRef) {
    // Initialize with current screen dimensions
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  ngOnInit(): void {
    // Initialize screen dimensions on component load
    this.updateScreenDimensions();
  }

  // HostListener to listen for window resize events in real-time
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    
    this.updateScreenDimensions();
  }

  // Custom function to update screen width and height
  updateScreenDimensions() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    // Manually trigger change detection to update the view
    this.cdRef.detectChanges();
  }

  // Function to get the current screen dimensions
  getScreenDimensions() {
    return {
      width: this.screenWidth,
      height: this.screenHeight,
    };
  }
}
